export enum StatusBeneficiaryExternalApiEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  NOT_FOUND = "not_found",
  ERROR = "error",
}
